import { RequestState } from 'modules/types/common';

/**
 * Function used primarily in conjunction with the redundantRequestManager
 * to determine if a network request should be made or skipped
 */
export const shouldSkipNetworkRequest = (requestState: RequestState) => {
  if (requestState === RequestState.REQUESTING || requestState === RequestState.SUCCESS) {
    return true;
  }
  return false;
};
